import { useState, useRef, useEffect } from "react";
import { Card } from "@mui/material";
import { Button } from "@mui/material";
import {
  boxStyle,
  lebelStyle,
  Root,
  cardStyle,
  inputstyle,
  buttonStyle,
  buttonStyle2,
  buttonPosition,
  headerStyle,
} from "../style/style";
import { Box } from "@mui/material";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { getobj } from "../apicall/apicall";
import axios from "axios";
import { StyledTableCell } from "../style/style";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
//Optional Import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { validated } from "../apicall/validateform";
import Cookies from "js-cookie";

export default function ManufacturedDevice() {
  const [myfile, setmyfile] = useState({
    file: "",
  });
  const [totaldevice, settotaldevice] = useState();
  const inputRef = useRef(null);
  const [uploadedfile, setuploadedfile] = useState();
  const [name, setname] = useState("");

  useEffect(() => {
    const url = process.env.REACT_APP_ZEWA_URL + "manufacture-data/total/";
    const res = getobj(url);
    res.then(function (data) {
      settotaldevice(data);
    });
    const url2 = process.env.REACT_APP_ZEWA_URL + "manufacture-data/list/";
    const res2 = getobj(url2);
    res2.then(function (data) {
      //console.log(data);
      setuploadedfile(Object.values(data));
    });
  }, [myfile]);
  function checkformat(name) {
    let res = false;
    const ext = name.split(".")[1];
    const exts = ["xls", "csv", "xlsx"];
    const val = exts.map((i) => {
      return i === ext;
    });
    for (let i = 0; i < val.length; i++) {
      res = res || val[i];
    }
    return res;
  }

  const handleSubmit = async () => {
    console.log(validated(myfile), checkformat(name));
    if (validated(myfile) && checkformat(name)) {
      const url =
        process.env.REACT_APP_ZEWA_URL + "manufacture-data/?name=" + name;
      const uploadData = new FormData();
      uploadData.append("myfile", myfile);

      await fetch(url, {
        headers: {
          Authorization: "Token " + sessionStorage.getItem("token"),
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
        method: "GET",
      })
        .then(function (res) {
          // console.log(myfile.name)

          return res.json();
        })
        .then(function (data) {
          // console.log(data.url.url);
          const url = data.url.url;
          const data2 = data.url.fields;

          //console.log(data);
          const formdata = new FormData();
          Object.keys(data2).forEach((data) => {
            // console.log(data,data2[data])
            formdata.append(data, data2[data]);
          });

          formdata.append("file", myfile);
          // console.log(myfile);
          axios
            .post(url, formdata, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              //console.log(res);
              const url = process.env.REACT_APP_ZEWA_URL + "manufacture-data/";
              const uploadData = new FormData();
              uploadData.append("myfile", myfile);

              fetch(url, {
                headers: {
                  Authorization: "Token " + sessionStorage.getItem("token"),
                  "X-CSRFToken": Cookies.get("csrftoken"),
                },
                method: "POST",
                body: uploadData,
              })
                .then((res) => {
                  //  console.log(res);
                  setmyfile("");
                  NotificationManager.remove(NotificationManager.listNotify[0]);

                  NotificationManager.success(
                    "Device list successfully added.",
                    "List added",
                    2000
                  );
                  resetFileInput();
                  setname("")
                })
                .catch((err) => console.log(err));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => console.log(err));
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please choose a file or choose correct format");
    }
  };
  const resetFileInput = () => {
    inputRef.current.value = null;
  };
  return (
    <Root>
      <Root>
        <Box sx={boxStyle}>
          <Card sx={headerStyle}>Upload Device List</Card>
          <Card sx={cardStyle}>
            <p style={buttonPosition}>
              Total Devices: {totaldevice && totaldevice}
            </p>
            <form>
              <p>Select Device List file</p>
              <input
                ref={inputRef}
                type="file"
                style={inputstyle}
                onChange={(e) => {
                  setmyfile(e.target.files[0]);
                  //console.log(e.target.files[0].name);
                  setname(e.target.files[0].name);
                }}
              />
              <br />
              <small style={lebelStyle}>
                Only .csv and .xlsx type file accepted
              </small>
              <br />
              <Button
                variant="contained"
                color="primary"
                sx={buttonStyle2}
                onClick={handleSubmit}
              >
                Add
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={buttonStyle}
                onClick={resetFileInput}
              >
                Cancel
              </Button>
            </form>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <b>File Name</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Date</b>
                  </StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadedfile &&
                  uploadedfile.map((i) => {
                    return (
                      <TableRow>
                        <StyledTableCell>{i.name}</StyledTableCell>
                        <StyledTableCell>
                          {i.uploaded_at.split("T")[0]}
                        </StyledTableCell>
                        <StyledTableCell>
                          <a
                            href={
                              "https://zewa-device-file.s3.amazonaws.com/" +
                              i.name
                            }
                          >
                            <ArrowDownwardIcon />
                          </a>
                        </StyledTableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </Card>
        </Box>
        <NotificationContainer />
      </Root>
    </Root>
  );
}
